import { faCodeCompare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { Handle, Position } from "reactflow";
import { Text } from "../externalComponents/tailwind/text";

function WebhookNode({ id, data }) {
  const [jsonError, setJsonError] = useState(false);

  const validateJson = (body) => {
    try {
      JSON.parse(body);
      setJsonError(false);
    } catch {
      setJsonError(true);
    }
  };

  useEffect(() => {
    validateJson(data.body);
  }, [data.body]);

  const cleanUrl = (url) => {
    // eslint-disable-next-line no-useless-escape
    const regex = /^(?:https:\/\/)?(?:www\.)?([^\/]+)/;
    const match = url.match(regex);

    return match ? match[1] : url;
  };

  return (
    <div className="webhook-node relative" onClick={() => data.clickNode(id)}>
      <Handle type="target" position={Position.Left} />
      <br />
      <div className="flex p-5 w-full justify-between items-center relative">
        <FontAwesomeIcon
          icon={faCodeCompare}
          className="w-28 h-28 text-[#717171] opacity-5 absolute top-0 left-8"
        />
        <div className="flex items-center justify-start flex-col px-5 h-full pb-7 w-full">
          <Text className="text-xs font-bold w-full truncate rounded p-1">{`Webhook: ${data.name}`}</Text>
          <Text className="text-xs mt-2 w-full truncate">{`Method: ${data.method}`}</Text>
          <Text className="text-xs mt-2 w-full truncate">{`Url: ${cleanUrl(
            data.destinationUrl,
          )}`}</Text>
          {jsonError && (
            <div className="flex mt-2 absolute -top-1 left-1">
              <ExclamationTriangleIcon className="text-red-700 h-5 w-5 items-center justify-center" />
              <Text className=" text-red-700 text-xs flex items-center">
                Body can not be saved.
              </Text>
            </div>
          )}
        </div>
      </div>
      <br />
      <Handle type="source" position={Position.Right} />
    </div>
  );
}

export default WebhookNode;
